import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.1866 15.1862C17.8351 15.5377 17.2653 15.5377 16.9138 15.1862L12.4502 10.7226L7.98659 15.1862C7.63512 15.5377 7.06527 15.5377 6.7138 15.1862C6.36233 14.8347 6.36233 14.2649 6.7138 13.9134L11.8138 8.81341C12.1653 8.46194 12.7351 8.46194 13.0866 8.81341L18.1866 13.9134C18.5381 14.2649 18.5381 14.8347 18.1866 15.1862Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }